import React, { useState } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  VStack,
  HStack,
  Text,
  Checkbox,
  Icon,
  Box,
} from "@chakra-ui/react";
import { FaTimes } from "react-icons/fa";

interface Field {
  key: string;
  label: string;
}

interface ConfiguracaoPopoverProps {
  children: React.ReactNode;
  visibleFields: string[];
  onFieldsChange: (fields: string[]) => void;
  exibirFields?: Field[]; // Agora é opcional via props
  ocultarFields?: Field[]; // Também opcional
}

const ConfiguracaoPopover: React.FC<ConfiguracaoPopoverProps> = ({
  children,
  visibleFields,
  onFieldsChange,
  exibirFields = [
    { key: "notaFiscal", label: "Nota Fiscal" },
    { key: "container", label: "Container" },
    { key: "fornecedor", label: "Fornecedor" },
    { key: "processo", label: "Processo" },
    { key: "carga", label: "Carga" },
    { key: "di", label: "DI" },
    { key: "tipo", label: "Tipo" },
    { key: "data", label: "Data" },
  ],
  ocultarFields = [
    { key: "status", label: "Status" },
    { key: "informacoes", label: "Informações" },
    { key: "checkbox", label: "Checkbox" },
    { key: "operacoes", label: "Operações" },
  ],
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleFieldToggle = (fieldKey: string) => {
    const isVisible = visibleFields.includes(fieldKey);
    
    if (isVisible) {
      // Remover campo da lista de visíveis
      onFieldsChange(visibleFields.filter(field => field !== fieldKey));
    } else {
      // Adicionar campo à lista de visíveis
      // Validação especial para Carga e DI (apenas um pode estar selecionado)
      if (fieldKey === "carga" && visibleFields.includes("di")) {
        onFieldsChange([...visibleFields.filter(field => field !== "di"), fieldKey]);
      } else if (fieldKey === "di" && visibleFields.includes("carga")) {
        onFieldsChange([...visibleFields.filter(field => field !== "carga"), fieldKey]);
      } else {
        onFieldsChange([...visibleFields, fieldKey]);
      }
    }
  };

  return (
    <Popover isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <PopoverTrigger>
        <Box onClick={() => setIsOpen(true)}>
          {children}
        </Box>
      </PopoverTrigger>
      <PopoverContent width="280px" border="2px solid #117baa" borderRadius="xl">
        <PopoverArrow />
        <PopoverBody p={0}>
          {/* Header */}
          <Box
            bg="#0F4F6D"
            color="white"
            p={3}
            borderRadius="xl 0 0 0"
            position="relative"
          >
            <Text fontWeight="bold" textAlign="center">
              Configurações
            </Text>
            <Icon
              as={FaTimes}
              position="absolute"
              right={3}
              top="50%"
              transform="translateY(-50%)"
              cursor="pointer"
              onClick={() => setIsOpen(false)}
              bg="white"
              color="#0F4F6D"
              borderRadius="full"
              p={1}
              boxSize={5}
            />
          </Box>

          {/* Content */}
          <Box p={4} bg="white">
            {/* Seção Exibir */}
            <VStack align="stretch" spacing={2} mb={4}>
              <Text fontWeight="bold" color="gray.800">
                Exibir:
              </Text>
              {exibirFields.map((field) => (
                <HStack key={field.key} spacing={2}>
                  <Checkbox
                    isChecked={visibleFields.includes(field.key)}
                    onChange={() => handleFieldToggle(field.key)}
                    colorScheme="green"
                    size="md"
                  />
                  <Text fontSize="sm" color="gray.800">
                    {field.label}
                  </Text>
                </HStack>
              ))}
            </VStack>

            {/* Separador */}
            <Box height="1px" bg="gray.200" mb={4} />

            {/* Seção Ocultar */}
            <VStack align="stretch" spacing={2}>
              <Text fontWeight="bold" color="gray.800">
                Ocultar:
              </Text>
              {ocultarFields.map((field) => (
                <HStack key={field.key} spacing={2} cursor="pointer" onClick={() => handleFieldToggle(field.key)}>
                  <Box
                    width="16px"
                    height="16px"
                    border="1px solid gray.400"
                    borderRadius="full"
                    bg={visibleFields.includes(field.key) ? "white" : "red.500"}
                    position="relative"
                  >
                    {!visibleFields.includes(field.key) && (
                      <Box
                        position="absolute"
                        top="50%"
                        left="50%"
                        transform="translate(-50%, -50%)"
                        width="8px"
                        height="8px"
                        bg="white"
                        borderRadius="full"
                      />
                    )}
                  </Box>
                  <Text fontSize="sm" color="gray.800">
                    {field.label}
                  </Text>
                </HStack>
              ))}
            </VStack>
          </Box>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default ConfiguracaoPopover;